export default (title) => {
    switch (title) {
        case 'Patient Details':
            return { bg: '#268EBB', text: '#ffecdb' }
        case 'Incident Details':
            return { bg: '#242F40', text: '#f2f2f2' }
        case 'Past Medical History':
            return { bg: '#E32525', text: '#ffecdb' }
        case 'Assessment':
            return { bg: '#F28B1F', text: '#ffecdb' }
        case 'Vital Signs':
            return { bg: '#FADF08', text: '#616161' }
        case 'Treatment':
            return { bg: '#1F3D7C', text: '#ffecdb' }
        case 'Safeguarding':
            return { bg: '#85276A', text: '#ffecdb' }
        default:
            return { bg: '#242F40', text: '#f2f2f2' }
    }
}